const template=`
<main>
	<header>
		<ToolMenu></ToolMenu>
		<NavMenu></NavMenu>
	</header>
	<hr>
	<div id=router-body>
		<router-outlet></router-outlet>
	</div>
</main>

<style>
main{
	display: flex;
	flex-direction: column;
	position: fixed;
	top: 5px;
	left: 5px;
	right: 5px;
	bottom: 5px;
}
main > header{
	display: flex;
	justify-content: space-between;
}
main > hr{
	width: 100%;
}
main > div#router-body{
	height: 100%;
}
</style>
`;

import {Component} from "@angular/core";

@Component({
	selector: "app-root",
	template: template
})
export class AppComponent{}
